module.exports = __webpack_public_path__ + "img/12.a059a7e4.png";